import { PrototypeAccessManagement } from '../PrototypeAccessManagement';

type ShareHumanTestingPasscodeProps = {
  prototypeId: string;
};

/** @deprecated Prefer PrototypeAccessManagement — kept as testing-surface wrapper */
export const ShareHumanTestingPasscode = ({
  prototypeId,
}: ShareHumanTestingPasscodeProps) => (
  <PrototypeAccessManagement prototypeId={prototypeId} type="testing" />
);
